
module.exports = process.env.REACT_APP_NODE_ENV === 'production' ? require('./Root.prod') : require('./Root.dev')
